/**
 * V172 — Invoice Payments Ledger
 *
 * useInvoicePayments: fetches payment rows for an invoice (internal / staff view)
 * usePortalInvoicePayments: fetches payment rows for an invoice (portal / client view)
 */
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export interface InvoicePayment {
  id: string;
  amount: number;
  paid_at: string;
  status: 'active' | 'voided';
  voided_at?: string | null;
  voided_by?: string | null;
  voided_by_email?: string | null; // Theme 6b S2: prefer over voided_by UID for display
  void_reason?: string | null;
  recorded_by?: string | null;
  recorded_by_email?: string | null; // Theme 6b S2: prefer over recorded_by UID for display
  created_at: string;
  // SPEC-invoice-merge-history R3: provenance that survives a merge.
  method?: string | null;
  reference?: string | null;
  provider?: string | null;
  provider_payment_intent_id?: string | null;
  original_invoice_id?: string | null;
  original_invoice_number?: string | null;
  original_invoice_provenance?: string | null;
  invoice_id?: string;
  current_invoice_number?: string | null;
}

export function useInvoicePayments(
  invoiceId: string,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: ['invoice', invoiceId, 'payments'],
    queryFn: () => api.invoices.getPayments(invoiceId),
    enabled: options?.enabled !== undefined ? options.enabled : true,
  });
}

export function usePortalInvoicePayments(
  invoiceId: string,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: ['portal', 'invoice', invoiceId, 'payments'],
    queryFn: () => api.portalPayments.getPayments(invoiceId),
    enabled: options?.enabled !== undefined ? options.enabled : true,
  });
}
